import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Card.css';

const propTypes = {
  className: PropTypes.string,
  dark: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const defaultProps = {
  className: undefined,
  dark: false,
  tag: 'div',
};

const Card = ({ className, dark, tag: Tag, ...other }) => {
  const classes = classNames(
    className,
    'apollo-card',
    dark ? 'apollo-card-dark' : '',
  );

  return <Tag {...other} className={classes} />;
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default Card;
